import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-images.css';
var getClassNameList = classNames.bind(styles);
var UitkImage = /** @class */function (_super) {
  __extends(UitkImage, _super);
  function UitkImage(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      hideImage: false,
      hidePlaceholderImage: false
    };
    _this.handleError = _this.handleError.bind(_this);
    _this.handleSuccess = _this.handleSuccess.bind(_this);
    return _this;
  }
  UitkImage.prototype.shouldComponentUpdate = function (nextProps) {
    var hideImage = this.state.hideImage;
    if (nextProps.src && hideImage === true) {
      // This manually triggers an update and then forces a false to prevent a loop
      this.setState({
        hideImage: false
      });
      return false;
    }
    return true;
  };
  UitkImage.prototype.handleError = function (event) {
    var _a = this.props,
      blankDefault = _a.blankDefault,
      placeholderImage = _a.placeholderImage,
      additionalProps = _a.additionalProps;
    this.setState({
      hideImage: !!placeholderImage || !!blankDefault
    });
    if (additionalProps) {
      // To get around TypeScript error "Property does not exist on type object"
      var castedProps = additionalProps;
      if (castedProps.onError && typeof castedProps.onError === 'function') {
        castedProps.onError(event);
      }
    }
  };
  UitkImage.prototype.handleSuccess = function (event) {
    var additionalProps = this.props.additionalProps;
    if (!(additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps['data-lazy'])) {
      this.setState({
        hidePlaceholderImage: true
      });
    }
    if (additionalProps) {
      // To get around TypeScript error "Property does not exist on type object"
      var castedProps = additionalProps;
      if (castedProps.onLoad && typeof castedProps.onLoad === 'function') {
        castedProps.onLoad(event);
      }
    }
  };
  UitkImage.prototype.render = function () {
    var _a;
    var _b = this.props,
      blankDefault = _b.blankDefault,
      className = _b.className,
      placeholderImage = _b.placeholderImage,
      alt = _b.alt,
      src = _b.src,
      imgRef = _b.imgRef,
      lazyLoading = _b.lazyLoading,
      additionalProps = _b.additionalProps;
    var _c = this.state,
      hideImage = _c.hideImage,
      hidePlaceholderImage = _c.hidePlaceholderImage;
    var imageClasses = getClassNameList('uitk-image-media', className);
    var placeholderClass = getClassNameList('uitk-image-placeholder', (_a = {}, _a["uitk-image-placeholder-image"] = placeholderImage && !blankDefault && !hidePlaceholderImage, _a));
    var imageProps = __assign({
      className: imageClasses,
      ref: imgRef,
      src: src
    }, additionalProps);
    return React.createElement("div", {
      className: placeholderClass
    }, !hideImage && React.createElement("img", __assign({
      alt: alt
    }, imageProps, {
      onError: this.handleError,
      onLoad: this.handleSuccess,
      loading: lazyLoading === 'off' ? undefined : lazyLoading
    })));
  };
  UitkImage.displayName = 'UitkImage';
  UitkImage.defaultProps = {
    blankDefault: false,
    src: ''
  };
  return UitkImage;
}(React.Component);
export { UitkImage };